<template lang="html">
  <div class="header-container">
    <div class="nav-container">
      <div class="nav-content bg-light sticky">
      <!-- <div class="nav-content bg-light" v-bind:class="{ sticky: (isSticky || !showBanner) }"> -->
        <b-navbar
          variant="light"
          type="light"
          toggleable="md"
          id="mainNav"
          ref="mainNav">
          <!-- Order with search bar: 1. nav_collapse; 2. logo; 3. search-collapse 4. navbar -->

          <b-navbar-brand
            :to="{name: 'home'}"
            class="logo">
            <i class="swg-icon material-icons">build</i>So wird's gemacht
          </b-navbar-brand>

          <b-navbar-toggle target="nav_collapse">
            <i class="material-icons">menu</i>
            <i class="description">Menü</i>
          </b-navbar-toggle>

          <!-- <b-navbar-toggle target="search_collapse">
            <i class="description">Suche</i>
            <i class="material-icons">search</i>
          </b-navbar-toggle>

          <b-collapse
            id="search_collapse"
            is-nav>
              <b-nav-form class="ml-auto">
                <b-form-input size="sm" class="mr-sm-2" placeholder="Suche" v-model="searchTerm"></b-form-input>
                <b-button pill size="sm" class="my-2 my-sm-0" type="submit" v-on:click="search" style="padding: 0.2rem">
                  <i class="material-icons">search</i>
                </b-button>
              </b-nav-form>
          </b-collapse> -->

          <b-collapse
            id="nav_collapse"
            is-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item :to="{name: 'books'}">Bücher</b-nav-item>
              <b-nav-item :to="{name: 'articles'}">Artikel</b-nav-item>
              <!-- <b-nav-item :to="{name: 'videos'}">Videos</b-nav-item> -->
              <!-- <b-nav-item :to="{name: 'blog'}">Blog</b-nav-item> -->
              <!-- <b-nav-item-dropdown text="Bücher" right>
                <b-dropdown-item :to="{name: 'home'}">Alle</b-dropdown-item>
                <b-dropdown-item :to="{name: 'book', params: { slug: '3-1' }}">eBooks</b-dropdown-item>
                <b-dropdown-item :to="{name: 'book', params: { slug: '4-1' }}">Mit Vorschau</b-dropdown-item>
                <b-dropdown-item :to="{name: 'home', params: { authorSlug: '' }}">Weitere Autoren</b-dropdown-item>
                <b-dropdown-item v-if="isAuthenticated" :to="{name: 'book-new'}">Buch hinzufügen</b-dropdown-item>
              </b-nav-item-dropdown> -->
              <!-- <b-nav-item-dropdown text="Artikel" right>
                <b-dropdown-item :to="{name: 'book-edit', params: { slug: '7-1' }}">Alle</b-dropdown-item>
                <b-dropdown-item :to="{name: 'book', params: { slug: '6-1' }}">Ausschnitte</b-dropdown-item>
                <b-dropdown-item :to="{name: 'book', params: { slug: '7-1' }}">Anleitungen</b-dropdown-item>
                <b-dropdown-item :to="{name: 'books'}">Nach Auto</b-dropdown-item>
                <b-dropdown-item :to="{name: 'books'}">Nach Medientyp</b-dropdown-item>
                <b-dropdown-item v-if="isAuthenticated" :to="{name: 'book-new'}">Artikel hinzufügen</b-dropdown-item>
              </b-nav-item-dropdown> -->
              <b-nav-item :to="{name: 'author', params: { slug: 'dr-ruediger-etzold' }}">Autor</b-nav-item>
              <b-nav-item v-if="isAuthenticated" :to="{name: 'dashboard'}">Dashboard</b-nav-item>
              <!-- <b-nav-item v-if="isAuthenticated" @click="onLogoutClick">Abmelden</b-nav-item> -->
              <b-nav-form class="ml-auto">

                <b-input-group class="mr-sm-2">
                  <b-form-input size="sm" placeholder="Suche" v-model="searchTerm"></b-form-input>
                  <b-input-group-append>
                    <b-button pill size="sm" class="my-2 my-sm-0" type="submit" v-on:click="search" style="padding: 0.2rem">
                      <i class="material-icons">search</i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
    <div v-if="showBanner" class="swg-banner" ref="swg-banner">
      <img src="@/assets/swg-banner.png"></img>
    </div>

    <b-navbar
    id="breadcrumb" v-if="breadcrumb">
      <b-breadcrumb :items="breadcrumb"/>
    </b-navbar>
  </div>
</template>

<script>
import notification from '@/views/mixins/notification';
import { mapGetters } from "vuex";
import { LOGOUT, FETCH_SEARCH_TEXT } from "@/store/actions.type";

export default {
  mixins: [notification],
  data () {
    return {
      breadcrumb: null,
      isSticky: false,
      navOffset: 0,
      searchTerm: "",
    }
  },
  watch: {
    '$route' () {
      this.breadcrumb = this.$route.meta.breadcrumb
    }
  },
  props: {
    currentRoute: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    showBanner() {
      if (this.currentRoute) {
        return this.currentRoute == 'home'
      } else {
        return false
      }
    }
  },
  created () {
    // if (this.showBanner) {
      // window.addEventListener('scroll', this.scroll);
    // }
  },
  destroyed () {
    // window.removeEventListener('scroll', this.scroll);
  },
  methods: {
    onLogoutClick() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$bvToast.toast("Sie sind nun ausgeloggt", {
          title: "Erfolgreich abgemeldet!",
          variant: 'success'
        })
        this.$router.push({ name: "dashboard" });
      });
    },
    search(e) {
      e.preventDefault()

      this.$store.dispatch(FETCH_SEARCH_TEXT, this.searchTerm);
      this.$router.push({ name: "search"});
    },
    scroll () {
      if (this.showBanner) {
        if (window.pageYOffset >= this.$refs['swg-banner'].offsetHeight) {
          this.isSticky = true
        } else {
          this.isSticky = false
        }
      }
      // if (this.navOffset == 0) {
        // Get the navbar
        // var navbar = this.$refs['mainNav'];
        // var banner = this.$refs['swg-banner'];

        // Get the offset position of the navbar
        // this.navOffset = banner.offsetHeight;
      // }

    }
  },
};
</script>

<style lang="scss">
// Small tablets (portrait view)
// $screen-md-min: 768px;
.header-container {
  margin: auto;
  margin-bottom: 12px;
  .input-group-append {
    .material-icons {
      font-size: 20px
    }
  }
  .swg-banner {
    img {
      width: 100%;
      max-width: 1080px;
      margin: auto;
      display: block;
    }
  }
  .navbar-brand {
    padding-top: 0px;
  }
  .nav-container {
    height: 50px;
  }
  .nav-content {
    left:0;
    width: 100%;
    z-index: 10;
    position: sticky;
    top: 0;
    box-shadow: 0 0 5px rgba(#000, 0.15);
  }
  /* The sticky class is added to the navbar with JS when it reaches its scroll position */
  .sticky {
    position: fixed;
    top: 0;
    width: 100%;
  }
  #mainNav {
    height: 50px;
    width: 100%;
    padding: 0 0;
    line-height: 50px;
    margin: auto;
    @media (min-width: #{$screen-sm-min}) {
      padding: 0 20px;
      max-width: $max-width+40px;
    }
    @media (min-width: #{$screen-lg-min}) {
      padding: 0 35px;
      max-width: $max-width+70px;
    }
    .logo {
      line-height: 50px;
      font-size: 19px;
      font-weight: 500;
      color: $color-text-primary;
      text-decoration: none;
      float: left;
      display: block;
      margin: 0;
      padding: 0 0.75rem; // Because search collapse is gone
      .swg-icon {
        vertical-align: middle;
        width: 30px; height: 30px;
        border-radius: 30px;
        border: $color-accent solid 3px;
        line-height: 1.2em;
        font-size: 20px;
        margin-right: 12px;
        padding-left: 2.5px;
      }
      &.router-link-exact-active { text-decoration: underline; }
      @media (max-width: 330px) {
        font-size: 14px;
        .swg-icon {
          font-size: 18px;
          width: 27px;
          height: 27px
        }
      }
    }

    #search_collapse {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .navbar-collapse.show, .navbar-collapse.collapsing {
      margin-top: -5px;
      background-color: white;
      box-shadow: 0 0 5px rgba(#000, 0.15);
      padding-left: 48px;
      padding-right: 48px;
    }
    .navbar-toggler {
      height: 50px;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.65);
      border: none;
      .material-icons { float:left;}
      .description {
        font-size: 0.75em;
        font-weight: 300;
        padding-top: 6px;
        font-style: normal;
        float: left;
        @media (max-width: 400px) {display: none}
      }
    }
    .show > .nav-link:after {
      border-top: 0;
      border-right: 0.3em solid transparent;
      border-bottom: 0.3em solid;
      border-left: 0.3em solid transparent;
    }
  }
  #breadcrumb {
    padding: 5px 10px;
    font-size: 0.8em;
    .breadcrumb {
      margin-bottom:0;
      background-color: transparent;
    }
  }
  #nav_collapse {
    a {
      &.router-link-exact-active { color: darken($color-accent,15); }
    }
  }
  .dropdown-item {
    &.active {
      background-color: $color-accent;
      color: $color-text-primary;
    }
    &:active {
      background-color: lighten($color-accent,10);
      color: $color-text-primary;
    }
  }
  .dropdown-menu {
    border: none;
    overflow: hidden;
    @media (min-width: #{$screen-sm-min}) {box-shadow: 0 0 5px rgba(#000, 0.15);}
  }
}
</style>
